export default function isEmbedded() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
